import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { MDXRenderer } from 'gatsby-plugin-mdx';

const SiteMessage = () => {
  return (
    <StaticQuery
      query={graphql`
        query GetContent {
          allMdx(
            filter: { frontmatter: { component: { eq: "siteMessage" } } }
          ) {
            edges {
              node {
                body
                frontmatter {
                  show
                }
              }
            }
          }
        }
      `}
      render={(data) =>
        data.allMdx.edges[0].node.frontmatter.show == true && (
          <div className="site-banner--message cell small-12 callout">
            <MDXRenderer>{data.allMdx.edges[0].node.body}</MDXRenderer>
          </div>
        )
      }
    />
  );
};

SiteMessage.defaultProps = {
  data: undefined,
};

SiteMessage.propTypes = {
  data: PropTypes.object,
};

export default SiteMessage;
